﻿import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'keepHtml', pure: false })
 
export class EscapeHtmlPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {
    }
    // WARNING: use this pipe only when you know the data source. Otherwise website may subject to XSS attack
    transform(content) {
        return this.sanitizer.bypassSecurityTrustHtml(content);
    }
}